/* eslint-disable */
/// This file is auto generated - do not edit manually
export const ScoreFunction = 'Website.ExplainedScores.ScoreFunction';
export const Score = 'Website.ExplainedScores.Score';
export const Explanation = 'Website.ExplainedScores.Explanation';
export const Calculation = 'Website.ExplainedScores.Calculation';
export const ParameterName = 'Website.ExplainedScores.ParameterName';
export const ParameterValue = 'Website.ExplainedScores.ParameterValue';
export const Addition = 'Website.ExplainedScores.Addition';
export const Multiplier = 'Website.ExplainedScores.Multiplier';
export const TotalSum = 'Website.ExplainedScores.TotalSum';
export const TotalMultipliers = 'Website.ExplainedScores.TotalMultipliers';
export const Total = 'Website.ExplainedScores.Total';
